import React from "react";
import {
  AnalyticsContext,
  ViewDataHandlingEvent,
} from "../common/context/AnalyticsContext";
import { DataHandling } from "./DataHandling";

export const DataHandlingPage: React.FC = () => {
  React.useState<Boolean>(false);
  const { logEvent } = React.useContext(AnalyticsContext);

  React.useEffect(() => {
    logEvent(new ViewDataHandlingEvent(false));
  }, [logEvent]);

  return <DataHandling showsTermsOfUseConsent={false} />;
};
